"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFromUrl = exports.fetchFromUrlResultSchema = exports.fetchFromUrlArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.fetchFromUrlArgsSchema = zod_1.z.object({
    url: zod_1.z
        .string()
        .describe('required: The URL to fetch content from. Automatically detects the best fetching method based on the URL (Twitter/X, Instagram, YouTube, Reddit, LinkedIn profiles, WordPress, or general web fetch). Supports flexible URL formats - protocol is optional. Examples: "https://twitter.com/user/status/123", "instagram.com/p/ABC123", "youtube.com/watch?v=xyz", "reddit.com/r/subreddit/comments/abc", "example.com"'),
    timeout: zod_1.z
        .number()
        .default(15000)
        .describe('required: The timeout for the fetch in milliseconds. Default 15000.'),
    emitMode: common_1.emitModeSchema,
});
// Result schema
exports.fetchFromUrlResultSchema = zod_1.z.object({
    success: zod_1.z.boolean().describe('Whether the URL fetch was successful'),
    method: zod_1.z
        .enum(['twitter', 'instagram', 'youtube', 'reddit', 'linkedin', 'wordpress', 'web'])
        .describe('The fetching method that was used'),
    status: zod_1.z.number().nullish().describe('HTTP status code of the response (if applicable)'),
    content: zod_1.z
        .string()
        .nullish()
        .describe('The content extracted from the URL (HTML for web pages, text for other platforms)'),
    text: zod_1.z
        .string()
        .nullish()
        .describe('The extracted text content (cleaned and readable, available for web pages)'),
    metadata: zod_1.z
        .object({
        title: zod_1.z.string().nullish().describe('Title of the content'),
        description: zod_1.z.string().nullish().describe('Description of the content'),
        author: zod_1.z.string().nullish().describe('Author or creator of the content'),
        publishedAt: zod_1.z.string().nullish().describe('Publication date (if available)'),
        url: zod_1.z.string().nullish().describe('The actual URL that was fetched'),
        platform: zod_1.z.string().nullish().describe('The platform or source of the content'),
    })
        .nullish()
        .describe('Metadata extracted from the content'),
    rawData: zod_1.z
        .any()
        .nullish()
        .describe('Raw data from the underlying fetch method (varies by method)'),
    error: zod_1.z.string().nullish().describe('Error message if the fetch failed'),
});
// Tool definition
exports.fetchFromUrl = (0, common_1.createEmitModeToolMetadata)({
    id: 'fetchFromUrl',
    displayName: 'Smart URL Fetch',
    displayDescription: 'Intelligently fetch content from any URL by automatically selecting the best method. Supports Twitter/X posts, Instagram posts/reels, YouTube videos, Reddit posts, LinkedIn profiles, WordPress pages, and general web pages. Returns standardized content and metadata.',
    category: 'search',
    color: common_1.BRAND_COLORS.BROWSER,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.BROWSER),
    icon: 'browser',
    argsSchema: exports.fetchFromUrlArgsSchema,
}, exports.fetchFromUrlResultSchema);
